import Server from "../server";
import {Promise, Thenable} from "es6-promise";
import {Spinner} from "../views/spinner";

export class S3 {

    private server: Server;

    private listener?: (status: string) => any;

    constructor(server: Server, listener?: (status: string) => any) {
        this.server = server;
        this.listener = listener;
    }

    public uploadFile(file: File) : Promise<string> {
        const filename = file.name;
        return this.uploadBlob(file, filename);
    }

    private uploadBlob(blob: Blob, filename: string) : Promise<string> {
        console.log("uploading blob...");

        var formData = new FormData();
        formData.append("file", blob);
        formData.append("filename", filename);

        return this.uploadFormData(formData);
    }

    private uploadFormData(formData: FormData) : Promise<string> {

        const me = this;

        const now = Date.now();

        const progressListener: (e: ProgressEvent) => void = (e) => {
            const time = (Date.now() - now) / 1000;
            const percent = e.lengthComputable ? Math.round(100 * e.loaded / e.total) + "%" : "NA";
            console.log(`Uploaded ${percent} : ${e.loaded} of ${e.total} (computable=${e.lengthComputable}) after ${time} seconds`);
            this.listener && this.listener(percent !== "100%" ? `Uploading... ${percent}` : "Processing");
        };

        // Processing on server is asynchronous.
        const out = new Promise<string>((resolve, reject) => {

            const url_ = this.server.ajax({
                url: `api/s3`,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                method: 'POST',
            }, {
                timeoutMs: 60 * 60 * 1000,
                uploadProgressListener: progressListener
            });

            url_.catch(err => {
                reject(err);
            });

            url_.then(url => {

                this.listener && this.listener("Processing...");

                const until = Date.now() + 5 * 60 * 1000;

                const test = () => {

                    const fail = () => {
                        const retry = Date.now() < until;
                        if (retry) {
                            setTimeout(test, 5000);
                        } else {
                            reject("Upload failed (timeout)");
                        }
                    }

                    me.testURL(url, 5 * 1000).then((ok) => {
                        if (ok) {
                            this.listener && this.listener("");
                            resolve(url);
                        } else {
                            fail();
                        }
                    });

                }

                test();

            });

        });

        const pop = Spinner.pushSpinner();

        out.finally(pop);

        return out;

    }

    private testURL(url: URL, timeoutMS: number) : Promise<boolean> {

        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();

            req.timeout = timeoutMS;

            req.onreadystatechange = () => {
                if (req.readyState === 4) {
                    resolve(req.status == 200)
                }
            }

            req.open("HEAD", url, true);
            req.send(null);
        });
    }
}
